import { Injectable } from '@angular/core';
import { Http, Headers } from '@angular/http';
import { Student} from "../Models/student";

import 'rxjs/add/operator/toPromise';
import 'rxjs';
import { Observable } from 'rxjs';


@Injectable()
export class StudentService {

  private headers = new Headers({'Content-Type': 'application/json'});
  private studentsUrl = 'api/students';  // URL to web api

  student = null;

  constructor(private http: Http) { }

  getStudentbyPin(id: any) {
    let school = Number(localStorage.getItem('school'));
    const url = `${this.studentsUrl}/${school}/${id}`;
    let data = this.http.get(url)
      .map(data => data.json());
    this.student = data;
    return data;
  }

  // Return cache student
  getStudent() {
    return this.student;
  }

}



// WEBPACK FOOTER //
// /home/hihoo/ibilling/attendence/public/src/app/Service/student.service.ts